<script setup>

import {onMounted, ref} from "vue";

const emit = defineEmits(['close'])

const props = defineProps({
    domain: {
        type: [String, null],
        required: false,
        default: null,
    },
    email: {
        type: [String, null],
        required: false,
        default: null,
    },
    url: {
        type: [String, null],
        required: false,
        default: null,
    },
    showIn: {
        type: String,
        required: false,
        default: 'slideout',
    },
    loadOnMount: {
        type: Boolean,
        required: false,
        default: true,
    }
})

const _domain = ref('')
const parsingPerformed = ref(false)

const getDomainFromUrl = async () => {
    const res = await axios.post(route('add-insights.get-domain-from-url'), {
        url: props.url,
    })

    if (res.data.success) {
        parsingPerformed.value = true
        return res.data.domain
    }
}

const getDomainFromEmail = async () => {
    const res = await axios.post(route('add-insights.get-domain-from-email'), {
        email: props.email,
    })

    if (res.data.success) {
        parsingPerformed.value = true
        return res.data.domain
    }
}

const getDomainFromInput = async () => {
    if (!props.domain && !props.email && !props.url) {
        _domain.value = null
        return
    }

    if (props.domain && props.domain.length > 2) {
        _domain.value = props.domain
        return
    }

    if (props.url) {
        _domain.value = await getDomainFromUrl(props.url)
        return
    }

    if (props.email) {
        _domain.value = await getDomainFromEmail(props.email)
    }
}

const onClose = () => {
    emit('close')
}

onMounted(() => {
    getDomainFromInput()
})

</script>

<template>
    <div>
        <add-insights-domain
            v-if="_domain"
            :domain="_domain"
            @close="onClose"
        />
    </div>
</template>

<style scoped>

</style>
